import React, { useEffect, useState } from "react";
import { Title, Text } from "rizzui/typography";
import { Button } from "rizzui";
import AccountBox from "../../component/accountBox";
import { useNavigate } from "react-router";

export default function LinkSent() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Reset Password";
  }, []);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClick = () => {};

  return (
    <AccountBox>
      <div className="flex flex-col gap-[32px]">
        <div className="flex flex-col gap-[8px]">
          <Title className="text-[18px] font-[600] text-primary-dark text-center font-ibmPlexSerif">
            {" "}
            Password link sent{" "}
          </Title>
          <Text className="text-[14px] leading-[18.48px] font-[400] text-secondary-dark text-center font-switzer">
            We’ve sent you a link to recover your password, check your email or
            junk
          </Text>
        </div>

        <div className="text-secondary-dark font-switzer text-center">
          <Button
            variant="solid"
            className="bg-btn rounded-[4px] text-[12px] font-[500] font-switzer w-[216px] h-[40px]"
            isLoading={isLoading}
            onClick={handleClick}
          >
            Go to mail
          </Button>
        </div>
      </div>
    </AccountBox>
  );
}
